import { call, SagaGenerator } from "typed-redux-saga";

import {
	DataOperation,
	maybeAsyncFnWrapper,
	OverviewEngineFactories
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";

import { assertTrue } from "../../utilities/assert";
import { ModulfOverviewEngineDataLoader } from "../../app/provider/modulfOverviewEngineDataLoader";

import { Paths, STAMMDATEN_MODEL_SUFFIX, STAMMDATEN_PAGE_SIZE } from "./constants";

export const stammdatenLoader: ModulfOverviewEngineDataLoader = {
	*canHandle(params): SagaGenerator<boolean> {
		const { queries, documentModel } = params;
		if (!documentModel.header.id.endsWith(STAMMDATEN_MODEL_SUFFIX)) {
			return false;
		}

		const [query] = queries;
		return yield* call(DataOperation.ListDocuments.Query.isAssignableFrom, query);
	},

	*provideData(params): SagaGenerator<DataOperation.ResultSet> {
		const { queries } = params;
		const [query, ...otherQueries] = queries;
		let updatedQuery = query;

		assertTrue(DataOperation.ListDocuments.Query.isAssignableFrom(query));

		updatedQuery = {
			...query,
			fields: [...(query.fields ?? []), Paths.IS_AUTOMATICALLY_CREATED, Paths.IS_EDITING_ALLOWED],
			paging: {
				...query.paging,
				pageSize: STAMMDATEN_PAGE_SIZE
			}
		};

		return yield* call(maybeAsyncFnWrapper(OverviewEngineFactories.dataLoader.provideData), {
			...params,
			queries: [updatedQuery, ...otherQueries]
		});
	}
};
